import { getToast } from "../../common/utils";
import { getProjectMappings } from "../../services/auth.service";
import { createArticleSession, getArticleList } from "../../services/common.service";

export const COMMON_ACTIONS = {
  ADD_BREADCRUMB: "ADD_BREADCRUMB",
  REMOVE_BREADCRUMB: "REMOVE_BREADCRUMB",
  SET_HISTORY: "SET_HISTORY",
  RESET_HISTORY: "RESET_HISTORY",
  SET_SESSION_ID: "SET_SESSION_ID",
  SET_ARTICLE_LIST: "SET_ARTICLE_LIST",
  SET_SELECTED_ARTICLE: "SET_SELECTED_ARTICLE",
};

export const setHistoryThunk = (path: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.SET_HISTORY,
        payload: path,
      });
    } catch (err) {}
  };
};

export const resetHistoryThunk = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.RESET_HISTORY,
      });
    } catch (err) {}
  };
};

export const updateMetaThunk = () => {
  return async (dispatch: any) => {
    try {
      const response = await getProjectMappings();
      if (
        response &&
        response.project_names &&
        response.project_names.length > 0
      ) {
        const projectName = response.project_names[0];
        localStorage.setItem("projectName", projectName);
        if (projectName === "Mayo") {
          document.title = "MAYO";
        } else if (projectName === "Luma") {
          document.title = "LUMA";
        } else {
          document.title = projectName.toUpperCase();
        }
        const link = document.querySelector(
          "link[rel*='icon']"
        ) as HTMLLinkElement | null;
        if (link) {
          link.href = `${
            process.env.PUBLIC_URL
          }/${projectName.toLowerCase()}_logo.svg`;
        } else {
          const newLink = document.createElement("link");
          newLink.type = "image/x-icon";
          newLink.rel = "shortcut icon";
          newLink.href = `${
            process.env.PUBLIC_URL
          }/${projectName.toLowerCase()}_logo.svg`;
          document.getElementsByTagName("head")[0].appendChild(newLink);
        }
      }
    } catch (error) {
      console.error("Error fetching project name:", error);
    }
  };
};

export const createArticleSessionThunk = () => {
  return async (dispatch: any) => {
    try {
      const response = await createArticleSession();
      if (response?.status && response?.session_id) {
        dispatch({
          type: COMMON_ACTIONS.SET_SESSION_ID,
          payload: response.session_id,
        });
        return { session_id: response.session_id }; // <-- return session_id
      }
    } catch (err) {
      console.error("Failed to create article session", err);
      getToast("Error", "Error in creating Session!");
    }
  };
};

export const fetchArticleListThunk = () => {
  return async (dispatch: any) => {
    try {
      const response = await getArticleList();
      if (response?.status && Array.isArray(response.articles)) {
        dispatch({
          type: COMMON_ACTIONS.SET_ARTICLE_LIST,
          payload: response.articles,
        });
      }
    } catch (err) {
      // Handle error
      console.error("Failed to fetch articles", err);
    }
  };
};

export const setSelectedArticleThunk = (article: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: COMMON_ACTIONS.SET_SELECTED_ARTICLE,
      payload: article,
    });
  };
};
